/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@vendor/swiper/swiper-bundle.min.js?201eb9a6b032a303cb6ab7f0';

const topSwiper = new Swiper('.j-banner-swiper', {
  speed: 1000,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
});

$('.c-banner').on('click', (e) => {
  const $this = $(e.currentTarget);

  window.open($this.data('url'), '_blank');
});

const logo = $('.j-store-slider').owlCarousel({
  items: 1,
  loop: true,
  dots: false,
  nav: false,
  margin: 30,
});

$('.j-slider-left').on('click', function () {
  logo.trigger('prev.owl.carousel');
});

$('.j-slider-right').on('click', function () {
  logo.trigger('next.owl.carousel');
});

$('[data-event]').each((i, ele) => {
  const container = ele.querySelector('.l-event__products');

  new Swiper(container, {
    // speed: 1000,
    slidesPerView: 2,
    slidesPerColumn: 1,
    grid: {
      fill: 'row',
      rows: 2
    },
    spaceBetween: 30,
    breakpoints: {
      992: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 15,
        grid: {
          fill: 'row',
          rows: 2
        },
      },
      1200: {
        slidesPerView: 3,
        slidesPerColumn: 3,
        spaceBetween: 30,
        grid: {
          fill: 'row',
          rows: 2
        },
      }
    },
    rewind: true,
    navigation: {
      nextEl: ele.querySelector('.swiper-button-next'),
      prevEl: ele.querySelector('.swiper-button-prev'),
    },
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
  });
});
